@let dimming = ui.dimming() ;

<app-lib-dimmer [dimmed]="dimming.dimmed"
                [title]="dimmerMsg().title!"
                [message]="dimmerMsg().message!"
                [showProgress]="!dimming.asStopMessage"
                [dimLevel]="dimming.dimLevel"
                position="top"
                [fullscreen]="true">
  @if (dimming.asStopMessage) {
    <app-lib-card
      style="max-width: 600px;"
      [title]="dimming.title"
      [type]="ActionType.Danger"
      ngClass.lt-md="p-24"
    >
      <ng-template templateFor="content">
        <div class="p-16 text-center" fxLayout="column">

          <p class="text-primary"><app-message-text [text]="dimming.message" [linkClass]="dimming.supportLinkClass" /></p>

          @if (dimming.action; as onActionClick) {
            <div slot="footer" fxLayout="row [wrap]" fxLayoutAlign="center bottom" fxLayoutGap="1rem" class="pt-24"
                 fxFlex>
              <button type="button" class="btn step-next"
                      id="back-btn"
                      (click)="handleErrorAction(onActionClick.onClick)">
                {{ onActionClick.label }}
              </button>
              <br/>
            </div>
          }

          @if(app.error(); as error) {
            @if(error.messageCode.code; as code) {
              <span style="opacity: 0.5" class="pt-12 text-secondary pk_dialog_code--{{code}}">Code: {{code}}</span>
            }
            @if(error.traceId) {
              <span style="opacity: 0.35" class="pt-12 text-secondary">{{error.traceId}}</span>
            }
          }
        </div>
      </ng-template>
    </app-lib-card>
  }
</app-lib-dimmer>

<!--<button (click)="test()">Test</button>-->
@if (config.inMaintenance()) {
  <app-lib-maintenance [config]="config.maintenance!"
                   supportNumber="{{config.support.default}}"
                   logoPath="/mindpath-logo.svg"
                   appName="Online scheduling"></app-lib-maintenance>

} @else {

  @if(debuggerOpen()) {
    <div style="width: 500px; height: 500px; position: absolute; top: 25px; left: 25px; z-index: 9999">
      <app-events-debugger style="width: 100%; height: 100%" ></app-events-debugger>
    </div>
  }
  @if (app.ready()) {
    <app-page-view></app-page-view>
  }

}
